import { Helmet } from 'react-helmet-async'
import { surface } from '../surface'

// Per-page SEO — react-helmet-async, mirroring the sister projects' meta patterns (title, description,
// canonical, OG). Kept lightweight for the prototype.
export function PageMeta({
  title,
  description,
  path = '/',
}: {
  title?: string
  description?: string
  path?: string
}) {
  const t = title ?? surface.title
  const d = description ?? surface.metaDesc
  const url = `https://${surface.domain}${path === '/' ? '' : path}`
  return (
    <Helmet>
      <html lang="en" />
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={`${surface.wordA}${surface.wordB}MCP`} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  )
}
